export const CONTACT_DETAILS = "/account/contact-details";
export const PRINTING_SETTINGS = "/account/printing-settings";
export const COLLECTION_DEFAULTS = "/account/collection-defaults";
export const SHIPPING_DEFAULTS = "/account/shipping-defaults";
export const INVOICE_DEFAULTS = "/account/invoice-settings";
export const PAPERLESS_SETTINGS = "/account/paperless-settings";
